import {FormBuilder, FormArray, Validators, FormGroup} from '@angular/forms';
import {convertISOStringToDate, convertTimestampToTimeString} from '../date-time/date-time.utils';
import {DoctorSettingsModel} from '../../app/models/doctor-settings/doctor-settings.model';

export function buildHolidaysFormArray(fb: FormBuilder, holidays: any[]): FormArray {
    return fb.array(
        holidays.map(holiday =>
            fb.group({
                from: [convertISOStringToDate(holiday.from), Validators.required],
                to: [convertISOStringToDate(holiday.to), Validators.required]
            })
        )
    );
}

export function buildConsultingHoursFormArray(fb: FormBuilder, consultingHours: any[]): FormArray {
    return fb.array(
        consultingHours.map(hour =>
            fb.group({
                day: [hour.day, Validators.required],
                from: [convertTimestampToTimeString(hour.from), Validators.required],
                to: [convertTimestampToTimeString(hour.to), Validators.required]
            })
        )
    );
}

export function buildDoctorSettingsForm(fb: FormBuilder): FormGroup {
    return fb.group({
        id: fb.control(''),
        consultingHours: fb.array([]),
        holidays: fb.array([]),
        consultantDurationInMinutes: fb.control(0, Validators.min(1)),
        treatmentCosts: fb.control(0),
        prescriptionCosts: fb.control(0),
        customTextForEmail: fb.control(''),
        shippingCostsForPrescription: fb.control(0),
        aliacuraDebtCollectionFees: fb.control(0),
        aliacuraPortalFees: fb.control(0),
        aliacuraPostage: fb.control(0),
        signature: fb.control(''),
        stamp: fb.control(''),
        appointmentMaxToInWeeks: fb.control(0)
    });
}

export function patchDoctorSettingsToForm(
    fb: FormBuilder,
    form: FormGroup,
    doctorSettings: DoctorSettingsModel
): void {
    form.get('id')?.patchValue(doctorSettings.id);
    form.get('consultantDurationInMinutes')?.patchValue(doctorSettings.consultantDurationInMinutes);
    form.get('treatmentCosts')?.patchValue(doctorSettings.treatmentCosts);
    form.get('prescriptionCosts')?.patchValue(doctorSettings.prescriptionCosts);
    form.get('customTextForEmail')?.patchValue(doctorSettings.customTextForEmail);
    form.get('shippingCostsForPrescription')?.patchValue(doctorSettings.shippingCostsForPrescription);
    form.get('aliacuraDebtCollectionFees')?.patchValue(doctorSettings.aliacuraDebtCollectionFees);
    form.get('aliacuraPortalFees')?.patchValue(doctorSettings.aliacuraPortalFees);
    form.get('aliacuraPostage')?.patchValue(doctorSettings.aliacuraPostage);
    form.get('signature')?.patchValue(doctorSettings.signature);
    form.get('stamp')?.patchValue(doctorSettings.stamp);
    form.get('appointmentMaxToInWeeks')?.patchValue(doctorSettings.appointmentMaxToInWeeks);

    if (doctorSettings.holidays?.length) {
        const holidaysFormArray = buildHolidaysFormArray(fb, doctorSettings.holidays);
        form.setControl('holidays', holidaysFormArray);
    }

    if (doctorSettings.consultingHours?.length) {
        const hoursFormArray = buildConsultingHoursFormArray(fb, doctorSettings.consultingHours);
        form.setControl('consultingHours', hoursFormArray);
    }
}
